<template>
    <div id="video-school-accounting">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <div class="resource-name">{{resourceName}}</div>
        </div>
        <div class="general-container">
            <el-table
                :data="accountingData"
                style="width: 100%">
                <el-table-column
                    label="学校信息"
                >
                    <template slot-scope="scope">
                        <router-link v-if="sendType !== 2" :to="{path: 'videoGradeAccounting', query: {schoolId: scope.row.schoolId, resourceId, resourceName}}">
                            {{scope.row.schoolName}}
                        </router-link>
                        <span v-else>{{scope.row.schoolName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="老师观看统计">
                    <el-table-column
                        label="已看"
                        width="120">
                        <template slot-scope="scope">
                            <router-link v-if="scope.row.thReadCount !== 0" :to="{path: 'videoWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'teacher'}}">
                                {{scope.row.thReadCount}}
                            </router-link>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="未看"
                        width="120">
                        <template slot-scope="scope">
                            <router-link v-if="scope.row.thNoReadCount !== 0" :to="{path: 'videoNotWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'teacher'}}">
                                {{scope.row.thNoReadCount}}
                            </router-link>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="name"
                        label="观看比例"
                        width="120">
                        <template slot-scope="scope">
                            <div>{{calcPercent(scope.row.thReadCount, scope.row.thReadCount + scope.row.thNoReadCount)}}%</div>
                            <div class="progress-bar">
                                <div class="progress-bar__full" :style="{width: `${calcPercent(scope.row.thReadCount, scope.row.thReadCount + scope.row.thNoReadCount)}%`}"></div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="学生观看统计">
                    <el-table-column
                        label="已看"
                        width="120">
                        <template slot-scope="scope">
                            <router-link v-if="scope.row.stuReadCount !== 0" :to="{path: 'videoWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">
                                {{scope.row.stuReadCount}}
                            </router-link>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="未看"
                        width="120">
                        <template slot-scope="scope">
                            <router-link v-if="scope.row.stuNoReadCount !== 0" :to="{path: 'videoNotWatchList', query: {schoolId: scope.row.schoolId, resourceId, type: 'student'}}">
                                {{scope.row.stuNoReadCount}}
                            </router-link>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="观看比例"
                        width="120">
                        <template slot-scope="scope">
                            <div>{{calcPercent(scope.row.stuReadCount, scope.row.stuReadCount + scope.row.stuNoReadCount)}}%</div>
                            <div class="progress-bar">
                                <div class="progress-bar__full" :style="{width: `${calcPercent(scope.row.stuReadCount, scope.row.stuReadCount + scope.row.stuNoReadCount)}%`}"></div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    prop="allVisitorNum"
                    label="观看总次数"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="fluxCount"
                    label="总流量(Gb)"
                    width="120">
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { getAllSchoolReadDataList } from '@/api/accounting/accounting';
    import baseMixin from '@/mixins/baseMixin.js';
    export default {
        name: "videoSchoolAccounting",
        mixins: [baseMixin],
        data() {
            return {
                schoolType: parseInt(this.$route.query.schoolType),
                resourceId: this.$route.query.resourceId,
                accountingData: [],
                resourceName: this.$route.query.resourceName,
                sendType: this.$route.query.sendType
            }
        },
        created() {
            this.getResourceSchoolReadDataListFunc();
        },
        methods: {
            getResourceSchoolReadDataListFunc() {
                getAllSchoolReadDataList({
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo,
                    resourceId: this.resourceId,
                    searchType: this.schoolType
                })
                    .then(res => res.data)
                    .then(data => {
                        this.accountingData = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                        this.pagination.pages = data.data.pagination.pages;
                    })
            },
            calcPercent(value1, value2) {
                if(value2 === 0) {
                    return 0;
                } else {
                    const percent = value1 / value2 * 100;
                    return percent.toFixed(2);
                }
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getResourceSchoolReadDataListFunc();
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageNo = 1;
                this.pagination.pageSize = pageSize;
                this.getResourceSchoolReadDataListFunc();
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 12%;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }

    .general-container {
        width: 1320px;
        min-height: 560px;
        margin-top: 72px;
    }
    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .resource-name {
        @include middleIB;
        font-size: 22px;
        width: 60%;
        text-align: center;
    }
    .section {
        margin: 20px 0;
    }
    .progress-bar {
        width: 100%;
        height: 5px;
        background-color: #ddd;
        position: relative;
        .progress-bar__full {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            background-color: #20a0ff;
        }
    }
    .pagination-container {
        text-align: right;
    }
</style>
<style lang="scss">
    #video-school-accounting .cell {
        text-align: center !important;
    }
    #video-school-accounting a {
        color: #20a0ff !important;
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/videoSchoolAccounting.vue